import { render, staticRenderFns } from "./TeachRoomQues2.vue?vue&type=template&id=7f72f426&scoped=true&"
import script from "./TeachRoomQues2.vue?vue&type=script&lang=js&"
export * from "./TeachRoomQues2.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomQues2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TeachRoomQues2.vue?vue&type=style&index=1&id=7f72f426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f72f426",
  null
  
)

export default component.exports